<template>
  <div>
    <div class="all">
      <div class="my_headers">
        <my_header :msg="title_msg" :states="1"></my_header>
      </div>
      <div class="statusImg">
        <img v-if="getStatu === 1" src="@/static/images/my_index/dg.png" alt>
        <img v-else src="@/static/images/my_index/erri.png" alt>
      </div>
      <div class="statusTitle">
        <p>{{ statusTitle }}</p>
      </div>
      <div v-show="getStatu === 1" class="successBox">
        <p>优惠券已放入您的筑龙账户，</p>
        <p>请下载最新筑龙学社APP，使用优惠券</p>
      </div>
      <div v-show="getStatu === 2" class="failBox">
        <p class="failBox_p">{{ errMsg }}</p>
        <div class="failBoxImg" @click="go_lessonDetail()">
          <img :src="$route.query.thumb" alt>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import my_header from '@/components/common/heads.vue'
export default {
  components: {
    my_header
  },
  data() {
    return {
      title_msg: '领取优惠卷',
      statusTitle: '领取成功',
      getStatu: 0,
      errMsg: ''
    }
  },
  mounted() {
    if (this.$route.query.status === 1 || this.$route.query.status === '1') {
      this.getStatu = 1
      this.statusTitle = '领取成功'
    } else {
      this.getStatu = 2
      this.statusTitle = '领取失败'
      this.errMsg = this.$route.query.my_msg ? this.$route.query.my_msg : '该优惠券只有指定学员可以领取'
    }
  },
  methods: {
    go_lessonDetail() {
      window.location.href = `https://m.zhulong.com/edu/lesson_details?lesson_id=${this.$route.query.lessonId}`
    }
  }
}
</script>

<style lang="scss" scoped>
.failBoxImg {
  width: 597px;
  height: 375px;
  border: 3px solid #ccc;
  margin: 0 auto;
  margin-top: 107px;
  display: flex;
  align-items: center;
  img {
    width: 521px;
    height: 292px;
    margin: 0 auto;
  }
}
.failBox_p {
  text-align: center;
  font-size: 30px;
  padding: 50px 0 0 0;
}
.successBox {
  margin-top: 106px;
  p:nth-child(1) {
    text-align: center;
    color: #333;
    font-size: 30px;
  }
  p:nth-child(2) {
    text-align: center;
    color: #333;
    font-size: 30px;
    padding: 20px 0 0 0;
  }
}
.statusTitle {
  p:nth-child(1) {
    font-size: 40px;
    font-weight: 600;
    color: #333;
    text-align: center;
    padding-top: 33px;
  }
}
.goZhulong {
  height: 120px;
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 3px solid #ccc;
  img {
    width: 71px;
    height: 71px;
    margin-left: 30px;
  }
  .goZhulong_title {
    margin-left: 28px;
    p:nth-child(1) {
      font-size: 30px;
      color: #333;
    }
    p:nth-child(2) {
      color: #494949;
      letter-spacing: 1px;
    }
  }
  .goZhulong_btn {
    margin-left: 106px;
    button {
      width: 186px;
      height: 56px;
      border: 3px solid #ee2e2e;
      background: transparent;
      color: #ee2e2e;
      border-radius: 12px;
    }
  }
}
.statusImg {
  width: 100%;
  margin: 124px 0 0 0;
  img {
    display: block;
    width: 91px;
    height: 91px;
    margin: 0 auto;
  }
}
.all {
  background: url("../../../static/images/my_index/givesbg.png") no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  width: 100%;
  // position: relative;
  // bottom: 30px;
  // overflow: hidden;
}
.my_headers {
  border-bottom: 1px solid #e1e1e1;
}
</style>
